import { render, staticRenderFns } from "./TodayRoad.vue?vue&type=template&id=381c91da&scoped=true&"
import script from "./TodayRoad.vue?vue&type=script&lang=js&"
export * from "./TodayRoad.vue?vue&type=script&lang=js&"
import style0 from "./TodayRoad.vue?vue&type=style&index=0&id=381c91da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381c91da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VImg,VRow})
